import { BaseRestService } from "tdm-shared-core-library/shared/services/rest/base-rest.service";
export class LocalizedResourcesService extends BaseRestService {
    constructor(window, options) {
        super(window);
        this.options = options;
    }
    async getLocalizedResources() {
        try {
            return await this._get(this.options.endpoint, '/resources/tdp-common/resources.json');
        }
        catch (e) {
            console.warn(e);
            return {};
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9jYWxpemVkLXJlc291cmNlcy5zZXJ2aWNlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2R5bmFtaWMtZGF0YS9sb2NhbGl6ZWQtcmVzb3VyY2VzL2xvY2FsaXplZC1yZXNvdXJjZXMuc2VydmljZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUMsZUFBZSxFQUFDLE1BQU0sZ0VBQWdFLENBQUM7QUFHL0YsTUFBTSxPQUFPLHlCQUEwQixTQUFRLGVBQWU7SUFHMUQsWUFBbUIsTUFBYyxFQUFFLE9BQXlDO1FBQ3hFLEtBQUssQ0FBQyxNQUFNLENBQUMsQ0FBQztRQUNkLElBQUksQ0FBQyxPQUFPLEdBQUcsT0FBTyxDQUFDO0lBQzNCLENBQUM7SUFFTSxLQUFLLENBQUMscUJBQXFCO1FBQzlCLElBQUk7WUFDQSxPQUFPLE1BQU0sSUFBSSxDQUFDLElBQUksQ0FBTSxJQUFJLENBQUMsT0FBTyxDQUFDLFFBQVEsRUFBRSxzQ0FBc0MsQ0FBQyxDQUFDO1NBQzlGO1FBQUMsT0FBTyxDQUFDLEVBQUU7WUFDUixPQUFPLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDO1lBQ2hCLE9BQU8sRUFBRSxDQUFDO1NBQ2I7SUFDTCxDQUFDO0NBQ0oifQ==